export default {"src":"/_next/static/media/icon-level-7.8d7bd92e.svg","height":25,"width":52};